/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 * In case a static page (set in backend admin) corresponds to the path, show it, otherwise show page not found message.
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React, { Component } from 'react';
import { Map } from 'immutable';
import Loader from 'common/components/Loader/Loader';
import { createSuperAgent } from 'utils/requestUtils';
import { i18n, i18nValue } from 'utils/i18nUtils';
import './notFoundPage.scss';

export default class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      page: null,
    };

    let oldURL = document.referrer;
    console.log(oldURL);
  }

  componentWillMount() {
    if (this.props.params && this.props.params.unknownPath) {
      createSuperAgent({ path: '/i18n/page/load_page', query: { pathname: this.props.params.unknownPath } }).end(
        (err, res) => {
          if (!err && res && res.body && res.body.success && res.body.page) {
            this.setState({ ready: true, page: new Map(res.body.page) });
          } else {
            this.setState({ ready: true });
          }
        }
      );
    } else {
      this.setState({ ready: true });
    }
  }

  render() {
    return (
      <div className={this.state.page ? 'static-page' : 'not-found-page'}>
        <div className="page-banner">
          <div className="container">
            {this.state.ready && <b>{this.state.page ? i18nValue(this.state.page) : '404'}</b>}
          </div>
        </div>

        {this.state.ready ? (
          this.state.page ? (
            <div
              className="page-container page-content"
              dangerouslySetInnerHTML={{ __html: i18nValue(this.state.page, 'html') }}
            />
          ) : (
            <h2 className="page-container">{i18n('NOT_FOUND_MESSAGE')}</h2>
          )
        ) : (
          <Loader smallPadding={true} />
        )}
      </div>
    );
  }
}
